import {
  SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_ASTRO_MAP_REPORT,
  SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_AURA_SCAN_REPORT,
  SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_SOULMATE_REPORT,
} from "@/features/subscriptions/report-plan-codes"

import { requestMyAuraScanReport } from "@/features/aura-scan-report/api/aura-scan-report-service"
import { requestMySoulmateReport } from "@/features/soulmate-report"

import { requestMyAstroMapReport } from "../api/pdf-report-service"
import { ReportIds, type ReportId } from "../config/reports-data"
import { syncIncludedReportUnlock } from "../hooks/report-unlock-store"

function includesPlan(planIds: readonly string[], planId: string | null | undefined): boolean {
  return Boolean(planId && planIds.includes(planId))
}

/**
 * Provisional unlock at account-bind time (clock ≈ subscription start). Webapp
 * entry re-syncs from the real `subscription.startedAt` once subscriptions load.
 */
function startIncludedUnlockAtPurchase(reportId: ReportId): void {
  syncIncludedReportUnlock(reportId, Date.now())
}

/**
 * Post-account (after finalize): request included reports for the signed-in user
 * via the authed endpoints. Single create path — do not also call a public
 * checkout request (avoids duplicate jobs). Best-effort.
 */
export async function requestIncludedReportsForMe(params: {
  planId: string | null | undefined
  subscriptionId: string
  token: string
}): Promise<void> {
  const { planId, subscriptionId, token } = params

  if (includesPlan(SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_SOULMATE_REPORT, planId)) {
    startIncludedUnlockAtPurchase(ReportIds.Soulmate)
    try {
      await requestMySoulmateReport({ subscriptionId, token })
    } catch (err) {
      console.error("included soulmate report (me) request failed:", err)
    }
  }

  if (includesPlan(SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_ASTRO_MAP_REPORT, planId)) {
    startIncludedUnlockAtPurchase(ReportIds.AstroMap)
    try {
      await requestMyAstroMapReport({ subscriptionId, token })
    } catch (err) {
      console.error("included astro-map report (me) request failed:", err)
    }
  }

  if (includesPlan(SUBSCRIPTION_PLAN_IDS_WITH_INCLUDED_AURA_SCAN_REPORT, planId)) {
    startIncludedUnlockAtPurchase(ReportIds.AuraScan)
    try {
      await requestMyAuraScanReport({ subscriptionId, token })
    } catch (err) {
      console.error("included aura-scan report (me) request failed:", err)
    }
  }
}
